<template>
  <div id="index">
    <Header ref="header"></Header>
    <!-- 推荐产品 -->
    <div class="index5 productList" :class="morenDiv == false ? 'none':''" style="margin-top:20px">
      <div class="index5Box productListBox">
        <div class="newsDetails">
          <h4>{{newsDetails.articleTitle}}</h4>
          <h6>{{newsDetails.createTime}}</h6>
          <p v-html="newsDetails.articleContentString">{{newsDetails.articleContentString}}</p>
          <img :src="newsDetails.headImg" alt="">
          <p style="width:100%;height:500px"></p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components: {
    Header
  },
  data() {
    return {
      morenDiv:true,
      showLogin:true,
      EWMImg:false,
      EWMButton:true,
      newsDetails:{}
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getArticleDetails();
  },
  methods: {
    getArticleDetails(){
      this.$fetch('getArticleDetails',{id:this.$route.query.id}).then(res => {
       this.newsDetails = res.result
      })
    },
    //跳转产品详情
    toProductDetails(){
      this.$router.push({name:'ProductDetails',query: {id:'1'}})
    }
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/newsDetails.vue